var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{class:_vm.className,attrs:{"alt":_vm.info.logo,"height":_vm.info.height,"src":_vm.info.src,"width":_vm.info.width}})
}
var staticRenderFns = []

export { render, staticRenderFns }